import { useState } from "react";
import { Card, Col, Collapse } from "reactstrap";
import JobTitleCheckBox from "./JobTitleCheckBox";
import HeaderWithIcon from "../../Common/HeaderWithIcon";
import { AllJobTitle, JobHeading } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

const JobTitleClass = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Col xl="12">
      <Card>
        <HeaderWithIcon heading={JobHeading} isOpen={isOpen} setIsOpen={setIsOpen}/>
        <Collapse isOpen={isOpen}>
          <JobTitleCheckBox />
          <Btn className="btn-block text-center w-100" color="primary">{AllJobTitle}</Btn>
        </Collapse>
      </Card>
      </Col>
  );
};

export default JobTitleClass;
